import { useTranslation } from "react-i18next";
import { Badge } from "@/components/ui/badge";

export const StatusBadge = ({ status }) => {
  const { t } = useTranslation();
  return (
    <Badge className={`status-${status}`}>
      {t(`admin.dashboard.status.${status}`)}
    </Badge>
  );
};
